import InstanceActions from "../actions/recordm.actions.instance";
import SaveBehaviorsM from "../model/recordm.model.instance.save.behavior";

var RecordmCustomizingHelper = function(){

   const instanceCustomizers = {};
   const instanceChangeListeners = {};
   const instanceValidators = {};

   const instanceColumnCustomizers = {};
   const listingCustomizers = {};

   const allInstanceCustomizers = [];
   const allInstanceColumnsCustomizers = {};

   const importers = {};
   const definitionFilters = {};

   const menuCustomizers = [
   ];

   /*
   * Each batch action should have the same content as seen in InstanceActions (see recordm.actions.instance.js):
   * Example:
   * {
   *   key: "action-key",
   *   label: "Action Label",
   *   isAllowed: function(definitionM, indexedInstanceM, ctx) {},
   *   execute: function(definitionId, indexedInstancesM, ctx) {},
   *   executeOnQuery: function(definitionId, query, ctx) {}
   * }
   */
   const customBatchActions = [];

   const instanceSaveBehaviors = {};

   const getAllRelevantItems = function(customizersList, key) {
      //filter customizations matching the key but first replace
      //any wildcard used on 'key' (used while registering the customization) by the equivalent regular expression (ie, * becames .*)
      return Object.entries(customizersList)
         .filter((entry) => (new RegExp("^" + entry[0].replaceAll("*",".*")
            .replace(/[/\-\\^$+?()|[\]{}]/g, '\\$&') + "$")).test(key) )
         .flatMap((entry) => entry[1])
   }

   return {
      customizeInstances: function(defName, customizer){
         instanceCustomizers[defName] = instanceCustomizers[defName] || [];

         instanceCustomizers[defName].push(customizer);
      },

      customizeAllInstances: function(customizer){
         allInstanceCustomizers.push(customizer);
      },
      // Apply customizers to the instance details page
      applyCustomizations: function(defName, instance, presenter){
         allInstanceCustomizers
            .concat(getAllRelevantItems(instanceCustomizers,defName))
            .forEach((customizer) => customizer(instance, presenter));
      },

      instanceChangeListener: function(defName, eventName, listener){
         instanceChangeListeners[defName] = instanceChangeListeners[defName] || [];

         instanceChangeListeners[defName].push({
            eventName: eventName,
            listener: listener
         })
      },
      startListeners: function(core, defName){
         const relevantInstanceChangeListeners = getAllRelevantItems(instanceChangeListeners, defName);

         relevantInstanceChangeListeners.forEach((l) => {
            l.wrappingSubscriber = function(_event, data){
               setTimeout(() => {
                  if(data !== undefined && typeof data.value === 'undefined'){
                     // changes by id only send the new value
                     l.listener({value: data})
                  } else {
                     l.listener(data);
                  }
               }, 200);
            };

            core.subscribe(l.eventName, l.wrappingSubscriber);
         })
      },
      stopListeners: function(core, defName){
         const relevantInstanceChangeListeners = getAllRelevantItems(instanceChangeListeners, defName);
         relevantInstanceChangeListeners.forEach((l) => core.unsubscribe(l.eventName, l.wrappingSubscriber));

         delete instanceChangeListeners[defName];
      },

      validateInstances: function(defName, validator){
         instanceValidators[defName] = instanceValidators[defName] || [];

         instanceValidators[defName].push(validator);
      },

      applyValidations: function(defName, instance, oldInstance, callbacks){
         const validators = getAllRelevantItems(instanceValidators, defName);

         if(validators.length > 0){
            validators.forEach((validator) => {
               if(typeof validator === "function"){
                  // fn.length returns the number of arguments
                  // but rest parameters (...arg) do not count
                  // see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/length
                  const numArgs = validator.length;

                  // 0 = without args OR with one rest parameter
                  if(numArgs === 0 || numArgs >= 4){
                     validator(oldInstance, instance, callbacks.pass, callbacks.fail);
                  } else if(numArgs === 1 || numArgs === 3){
                     // 1 = with one arg OR with one arg and one rest parameter
                     validator(instance, callbacks.pass, callbacks.fail);
                  }
               }
            });

         } else {
            callbacks.pass();
         }
      },

      customizeColumn: function(defName, fieldName, customizer){
         //defName and fieldName supports wildcards
         const key = defName + '\0' + fieldName;
         instanceColumnCustomizers[key] = instanceColumnCustomizers[key] || [];

         instanceColumnCustomizers[key].push(customizer);
      },
      customizeColumns: function(defName, columns){
         //defName supports wildcards
         Object.keys(columns)
             .forEach((fieldName) => this.customizeColumn(defName, fieldName, columns[fieldName]));
      },
      customizeAllColumns: function(defName, customizer){
         //defName supports wildcards
         allInstanceColumnsCustomizers[defName] = allInstanceColumnsCustomizers[defName] || [];
         allInstanceColumnsCustomizers[defName].push(customizer);
      },
      getColumnCustomizations: function(defName, fieldName){
         let allColumnsCostumizers = getAllRelevantItems(allInstanceColumnsCustomizers, defName);
         let specificColumnCostumizers =  getAllRelevantItems(instanceColumnCustomizers, defName + '\0' + fieldName);
         return allColumnsCostumizers.concat(specificColumnCostumizers);
      },

      customizeListing: function(defName, customizer){
         listingCustomizers[defName] = listingCustomizers[defName] || [];

         listingCustomizers[defName].push(customizer);
      },
      getListingCustomizers: function(defName){
         return getAllRelevantItems(listingCustomizers,defName);
      },

      addCustomBatchActions: function (batchActionsArray) {
         batchActionsArray.forEach(this.addCustomBatchAction);
      },
      addCustomBatchAction: function (batchAction) {
         const errors = InstanceActions.validateBatchAction(batchAction);

         if(errors.length === 0 ) {
            customBatchActions.push(batchAction);
         }

         return errors;
      },
      getCustomBatchActions: function () {
         return customBatchActions;
      },

      /**
       * @param defName
       * @param saveBehavioursArray an array of save behaviors
       * Save behaviors should be like:
       *     {
       *        name: "save",               // Mandatory
       *        label: "Save",              // (Optional) Custom label for the button. Defaults to the name value
       *        icon: "icon-ok",            // (Optional) Custom icon for the button
       *        cssClasses: "some-class",   // (Optional) CSS classes to add to the action button
       *        newInstanceFields: []       // (Optional for save-create-new) an Array or a function:
       *                                    //      * Array: an array containing info about fields to use when creating a new instance (eg: ["Field 1", {"Field 2":"hardcoded value"}])
       *                                    //          * String element: the name of the field to fill on the new instance. Its value is obtained from the current instance being created/updated
       *                                    //          * Object: Field-value pair to use on the new instance. Its value is hardcoded
       *                                    //      * Function: a function that returns an Array like the previous one. It receives the current instance data as a parameter (eg: function(instanceData){})
       *     }
       *
       * Possible save behavior names:
       *     * save
       *     * save-edit
       *     * save-create-new
       */
      customizeSaveBehaviors: function (defName, saveBehavioursArray){
         instanceSaveBehaviors[defName] = saveBehavioursArray || [];
      },

      getSaveBehaviorsM: function (defName){
         return new SaveBehaviorsM(instanceSaveBehaviors[defName]);
      },

      /**
       * @param defName
       * @param importerConfigsArray an array of custom recordm-importer configurations
       * configurations should be like:
       *     {
       *        label: "Custom Importer",     // Label for the import button
       *        name: "custom-importer",     // The name to use in the record-importer path (eg: for the path "/recordm-importer/custom-importer/file", the value should be "custom-importer")
       *        icon: "icon-ok",             // (Optional) Custom icon for the button
       *        cssClasses: "some-class",    // (Optional) CSS classes to add to the import button,
       *     }
       */
      customizeImporters: function (defName, importerConfigsArray){
         importers[defName] = importerConfigsArray;
      },
      getCustomImports: function (defName){
         return importers[defName] ?? [];
      },

      /**
       * @param defName
       * @param filtersArray an array of filters
       * A filter should be like:
       *     {
       *        label: "Name to show in the UI",
       *        query: "*",
       *        selected: true | false // flag that sets the filter active or not, Default is false.
       *     }
       */
      customizeDefinitionSearchFilters: function(defName, filtersArray) {
         filtersArray.forEach(function(filter) {
            if (filter.query === null || filter.query === undefined) {
               throw new Error(
                   "A query was not defined in a custom filter of definition "+defName+": " + JSON.stringify(filter)
               );
            }

            filter.label = (filter.label || filter.query);
            filter.selected = Boolean(filter.selected);
         })

         console.debug("Added filters for " + defName, filtersArray)

         definitionFilters[defName] = filtersArray
      },

      getCustomDefinitionSearchFilters: function (defName){
         return definitionFilters[defName] ?? [];
      },

      customizeMenu: function(customizer){
         menuCustomizers.push(customizer);
      },
      getMenuCustomizers: function(){
         return menuCustomizers;
      }
   }
};

export default RecordmCustomizingHelper;
